/**
 * Video Grid Section — Shopify
 * Gère l'ouverture/fermeture du lightbox vidéo
 * Supporte : YouTube, Vimeo, vidéos natives HTML5
 */

(function () {
  'use strict';

  document.querySelectorAll('.video-grid-section').forEach(function (section) {
    const sectionId = section.id.replace('video-grid-', '');
    const lightbox = document.getElementById('video-lightbox-' + sectionId);

    if (!lightbox) return;

    const backdrop = lightbox.querySelector('.video-lightbox__backdrop');
    const closeBtn = lightbox.querySelector('.video-lightbox__close');
    const embedContainer = lightbox.querySelector('.video-lightbox__embed');
    const titleEl = lightbox.querySelector('.video-lightbox__title-text');
    const items = section.querySelectorAll('.video-grid__item');

    // ─── Ouvrir le lightbox ───────────────────────────────────────────────────
    function openLightbox(item) {
      const videoId = item.dataset.videoId;
      const videoType = item.dataset.videoType;
      const videoUrl = item.dataset.videoUrl;
      const videoTitle = item.dataset.videoTitle || '';

      embedContainer.innerHTML = '';
      titleEl.textContent = videoTitle;

      if (videoType === 'youtube') {
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = videoTitle;
        embedContainer.appendChild(iframe);

      } else if (videoType === 'vimeo') {
        const iframe = document.createElement('iframe');
        iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&title=0&byline=0&portrait=0';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.title = videoTitle;
        embedContainer.appendChild(iframe);

      } else {
        // Vidéo native (mp4, etc.)
        const video = document.createElement('video');
        video.src = videoUrl;
        video.controls = true;
        video.autoplay = true;
        video.style.width = '100%';
        video.style.height = '100%';
        embedContainer.appendChild(video);
      }

      lightbox.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      lightbox.classList.remove('is-closing');

      // Focus sur le bouton fermer pour l'accessibilité
      setTimeout(function () {
        closeBtn.focus();
      }, 50);
    }

    // ─── Fermer le lightbox ───────────────────────────────────────────────────
    function closeLightbox() {
      lightbox.classList.add('is-closing');

      // Stopper la lecture avant de fermer
      const iframe = embedContainer.querySelector('iframe');
      const video = embedContainer.querySelector('video');

      if (iframe) {
        // Stopper YouTube / Vimeo via src reset
        const src = iframe.src;
        iframe.src = '';
        iframe.src = src.replace('autoplay=1', 'autoplay=0');
      }
      if (video) {
        video.pause();
      }

      setTimeout(function () {
        lightbox.setAttribute('hidden', '');
        lightbox.classList.remove('is-closing');
        embedContainer.innerHTML = '';
        document.body.style.overflow = '';
      }, 250);
    }

    // ─── Événements ──────────────────────────────────────────────────────────

    // Clic sur un item de la grille
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        openLightbox(item);
      });

      // Accessibilité clavier
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openLightbox(item);
        }
      });
    });

    // Fermer via le backdrop
    backdrop.addEventListener('click', closeLightbox);

    // Fermer via le bouton X
    closeBtn.addEventListener('click', closeLightbox);

    // Fermer via Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !lightbox.hasAttribute('hidden')) {
        closeLightbox();
      }
    });
  });

})();